export default "__VITE_ASSET__jdyUuyxT__"